module.exports = __webpack_public_path__ + "img/07-min.998807fb.jpg";